import Styles from '../ShapesTab.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Images } from 'blaze-ui/icons'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { Editor, track } from '@tldraw/tldraw'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { ImageShapeUtil } from 'components/VisualStudioPlayground/Shapes/ImageShape/ImageShapeUtil'
import { Pressable } from '@react-aria/interactions'

interface Props {
  editor: Editor
  shape: ImageShape
}

export const BackgroundToggle = track(({ editor, shape }: Props) => {
  const shapeUtil = editor.getShapeUtil<ImageShape>(shape) as ImageShapeUtil
  const isBackground = shape.props.isBackground

  const toggleBackground = () => {
    shapeUtil.setIsBackground(shape, !isBackground)
  }

  return (
    <div className={Styles.colorSection}>
      <Pressable onPress={() => toggleBackground()}>
        <div className={Styles.actionRow}>
          <Images color="var(--selected-fill)" />
          <span className={Styles.actionName}>
            <Text variant="smallList">Background</Text>
          </span>
          <ToggleButton name="background" size="sm-md" checked={isBackground} handleChange={() => {}} />
        </div>
      </Pressable>
    </div>
  )
})
